// Received samples routes
export default [
  {
    path: 'received-samples',
    name: 'receivedSamples',
    redirect: 'received-samples/index',
    component: () =>
      import(
        /* webpackChunkName: "receivedSamples" */ '../views/receivedSamples/ReceivedSamples.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'receivedSamplesIndex',
        meta: {
          tabbable: true,
          tableKeys: ['receivedSamples'],
          filterKeys: ['receivedSamples'],
          formKeys: [],
          routePermissions: ['receivedSamplesView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "receivedSamplesIndex" */ '../views/receivedSamples/ReceivedSamplesIndex.vue'
          ),
      },
    ],
  },
];
